import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { get } from 'lodash'
import TonalButton from 'components/empty-page-state/tonal-button'
import AddIcon from 'components/material-symbol/icons/Add'
import { IconTrashcan } from 'components/atoms/icons'
import FormSubheader from '../create-profile-form/form-subheader'
import {
  getFieldProps,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

const MAX_TOOLS = 8
const toolsMsg = `Add up to ${MAX_TOOLS} tools that apply to your coaching practice.`

export const Tools = ({
  hideSubheader = false,
  filledDeleteButton = false,
}) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(fieldClasses)
  const { errors, getValues, setValue, register } = useFormContext()
  const [tools, setTools] = useState(() => getValues('toolJsonData') || [])

  useEffect(() => {
    register({ name: 'toolJsonData' })
    setValue('toolJsonData', getValues('toolJsonData') || [], {
      shouldDirty: false,
      shouldValidate: false,
    })
  }, [getValues, register, setValue])

  const updateTools = nextTools => {
    setTools(nextTools)
    setValue('toolJsonData', nextTools, {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  const addTool = () => {
    if (tools.length >= MAX_TOOLS) {
      return
    }

    updateTools([...tools, ''])
  }

  const removeTool = index => {
    updateTools(tools.filter((_, toolIndex) => toolIndex !== index))
  }

  const updateTool = (index, value) => {
    const nextTools = [...tools]
    nextTools[index] = value
    updateTools(nextTools)
  }

  return (
    <Box className={fieldClasses.fieldSection}>
      {!hideSubheader ? (
        <FormSubheader title="Tools" description={toolsMsg} />
      ) : null}
      <Box className={fieldClasses.fieldStack}>
        {tools.map((tool, index) => (
          <Box
            key={`tool-${index}-${tools.length}`}
            className={fieldClasses.repeaterRow}
          >
            <TextField
              {...fieldProps}
              name={`toolJsonData[${index}]`}
              label="Tool"
              type="text"
              value={tool || ''}
              onChange={event => updateTool(index, event.target.value)}
              error={!!get(errors, ['toolJsonData', index])}
            />
            <Button
              className={
                filledDeleteButton
                  ? fieldClasses.repeaterDeleteButtonFilled
                  : fieldClasses.repeaterDeleteButton
              }
              variant={filledDeleteButton ? 'contained' : 'outlined'}
              color="default"
              disableElevation={filledDeleteButton}
              size="large"
              type="button"
              startIcon={<IconTrashcan />}
              onClick={() => removeTool(index)}
            >
              Delete
            </Button>
          </Box>
        ))}
        <Box>
          <TonalButton
            type="button"
            startIcon={<AddIcon fontSize="small" />}
            onClick={addTool}
            disabled={tools.length >= MAX_TOOLS}
          >
            Add Tool
          </TonalButton>
        </Box>
      </Box>
    </Box>
  )
}

export default Tools
